
export default class MesspunktDto {

  constructor(json) {
    if (json) {
      this.json = json

      this.id = json.id;
      this.nummer = json.nummer;
    } else {
      this.json = {}
    }
  }
}
